<div class="loading-track">
  @if (isLoading$ | async) {
    <div role="status" class="loading-status">
      <span class="loading-label">Loading</span>
      <span class="loading-segment" aria-hidden="true"></span>
    </div>
  }
</div>
